import type { AccessProfileId, CommandDeckSurfaceMode } from '../contracts/types'
import type { CommandDeckWorkContextModel } from '../lib/commandDeckWorkContext'
import { CommandDeckStatusPill } from './CommandDeckStatusPill'
import {
  continueAlignedPill,
  workContextProfilePill,
  workContextRowPill,
} from './commandDeckStatusPillPresentational'

interface Props {
  model: CommandDeckWorkContextModel
  mode: CommandDeckSurfaceMode
  profileId: AccessProfileId
}

export function CommandDeckWorkContext({ model, mode, profileId }: Props) {
  const profilePill = workContextProfilePill(profileId)
  const alignedPill = continueAlignedPill(Boolean(model.nextSafeAction.continueLabel))

  return (
    <section
      className="cd-mc-work-context cd-mc-work-context--overlay"
      aria-labelledby="cd-mc-work-context-title"
    >
      <div className="cd-mc-work-context__title-row">
        <h3 id="cd-mc-work-context-title" className="cd-mc-work-context__title">
          {model.sectionTitle}
        </h3>
        <div className="cd-mc-work-context__title-pills">
          {profilePill ? (
            <CommandDeckStatusPill label={profilePill.label} variant={profilePill.variant} />
          ) : null}
          {mode === 'preview' ? (
            <CommandDeckStatusPill label="PREVIEW" variant="preview" />
          ) : null}
        </div>
      </div>

      <dl className="cd-mc-work-context__meta">
        {model.rows.map((row) => {
          const pill = workContextRowPill(row, mode)
          return (
            <div key={row.id} data-source={row.source}>
              <dt>
                {row.label}
                {pill ? (
                  <CommandDeckStatusPill
                    label={pill.label}
                    variant={pill.variant}
                    className="cd-mc-work-context__row-pill"
                  />
                ) : null}
              </dt>
              <dd>{row.value}</dd>
            </div>
          )
        })}
        <div data-source={model.nextSafeAction.source}>
          <dt>
            {model.nextSafeAction.label}
            {alignedPill ? (
              <CommandDeckStatusPill
                label={alignedPill.label}
                variant={alignedPill.variant}
                className="cd-mc-work-context__row-pill"
              />
            ) : null}
          </dt>
          <dd>
            {model.nextSafeAction.value}
            {model.nextSafeAction.continueLabel ? (
              <span className="cd-mc-work-context__continue-hint">
                {' '}
                (Continue: {model.nextSafeAction.continueLabel})
              </span>
            ) : null}
          </dd>
        </div>
      </dl>
    </section>
  )
}
